import React from 'react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-153" data-mp="30wohs94qq3vn">
      <div className="mx-auto max-w-4xl" data-id="element-154" data-mp="30zaz30hfnxr2">
        <div className="text-center" data-id="element-155" data-mp="2w5yfx5viwj5p">
          <h2 className="font-display text-[1.9rem] font-extrabold uppercase leading-tight text-ink sm:text-[2.6rem]" data-id="element-156" data-mp="2w4wxuhg3aweh">
            <span aria-hidden="true" data-id="element-157" data-mp="2r5al0946bi67">👉 </span>Do You Recognize Yourself in
            These Situations?
          </h2>
          <p className="mt-3 text-sm text-ink/55" data-id="element-158" data-mp="2i6qe057z6wxt">
            If you said yes to any of these — this pack is for you.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-159" data-mp="2d8f1tnu7kacf">
          {recognizeItems.map(item => <li key={item.text} className="flex items-start gap-3 rounded-xl border border-ink/5 bg-white px-4 py-4" data-id="element-160" data-mp="28adgsxd820yb">
              <span className="text-base leading-none" aria-hidden="true" data-id="element-161" data-mp="6gwem97v1say">
                {item.emoji}
              </span>
              <span className="text-xs font-medium leading-snug text-ink/80" data-id="element-162" data-mp="3jjiptdqsyspf">
                {item.text}
              </span>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-2xl font-bold uppercase text-brand sm:text-3xl" data-id="element-163" data-mp="39npge38drfbv">
          And you deserve so much more than that →
        </p>
      </div>
    </section>;
}